import Bundle from './appBundleResource';
import transformError from '../shared/transformers/errorTransformer';
import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';
import getFormData from '@/utils/getFormData';

function getBundle({ packageName, id }) {
  return Bundle.getBundle({ packageName, id })
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

function getBundleSignInfo({ packageName, id }) {
  return Bundle.getSignInfo({ packageName, id })
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

function sendBundleSign({ packageName, id, file }) {
  const formData = getFormData([file], 'file');

  return Bundle.sendSign({ packageName, id }, formData)
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

export default {
  getBundle,
  getBundleSignInfo,
  sendBundleSign,
};
